import MarketingTable from "./marketing-table";
import StatisticTable from "./statistic-table";
import RequiredTable from "./required-table";
import { useState } from "react";

const tableMap = new Map();
tableMap.set("required", RequiredTable)
tableMap.set("marketing", MarketingTable)
tableMap.set("statistic", StatisticTable)

const nameMap = {
    required: "Nødvendige",
    statistic: "Statistik",
    marketing: "Marketing"
}

function Details({ show }) {
    const [activeTable, setActiveTable] = useState("required")

    if (!show) return null

    return (
        <div>
            <div>
                {
                    Array.from(tableMap.keys())
                        .map(k => (
                            <button
                                className={`border p-2 ${activeTable === k ? "border-slate-400" : "border-slate-200"}`}
                                onClick={() => setActiveTable(k)}
                            >
                                {nameMap[k]}
                            </button>
                        ))
                }
            </div>
            <div
                className="h-52 overflow-y-scroll"
            >
                {
                    tableMap.get(activeTable)()
                }
            </div>
        </div>
    )
}

export default Details;